module.exports = __webpack_public_path__ + "img/up.52fc8ff1.svg";